<template>
  <div class="d-flex align-items-center">
    <BellOutlined
      style="color: white;cursor: pointer;"
      class="mr-3"
      @click="goToPage('notification')"
    />
    <UserOutlined
      style="color: white;cursor: pointer;"
      class="mr-3"
      @click="goToPage('forgot-password')"
    />
    <a-dropdown :trigger="['click']" placement="bottomLeft">
      <div :class="$style.dropdown">
        <span class="text-decoration-none mr-2" style="color: white;"
          >Hi, {{ user ? firstName : '' }}</span
        >
      </div>
      <template #overlay>
        <a-menu>
          <a-menu-item @click="logout">
            <!-- TO DO DUMMY FUNCTION, UNCOMMENT LINE BELOW -->
            <!-- <a class="text-danger" @click="logout"> -->
            <a class="text-danger">
              <i class="fe fe-log-out" />
              Keluar
            </a>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script>
import { UserOutlined, BellOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default {
  components: {
    UserOutlined,
    BellOutlined,
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const logout = () => {
      // TO DO DUMMY FUNCTION, UNCOMMENT LINE BELOW
      store.dispatch('user/LOGOUT')
      // router.push('/masuk')
    }
    const initialData = () => {
      const userData = JSON.parse(localStorage.getItem('userData'))
      user.value = userData.user
      // console.log(userData, 'inidaritobar')
    }
    const user = ref()
    const goToPage = page => {
      router.push(`/${page}`)
    }
    const firstName = computed(() => {
      if (user.value && user.value.name) {
        return user.value.name.split(' ')[0] // Ambil kata pertama dari nama
      }
      return ''
    })

    onMounted(() => {
      initialData()
    })

    return {
      firstName,
      goToPage,
      user,
      logout,
    }
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';

.notification-menu {
  max-width: 300px;
  padding: 10px;
  background-color: #f9f9f9;
}

.notification-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.notification-title {
  font-weight: 600;
  color: #333;
}

.text-danger {
  color: #f5222d;
}

.notification-description {
  font-size: 14px;
  color: #888;
  margin: 2px 0 0;
}

.notification-time {
  font-size: 12px;
  color: #999;
}
</style>
